import React, { useState } from "react";
import {
  ColumnFixing,
  DataGrid,
  Editing,
  Export,
  GroupItem,
  IDataGridOptions,
  Pager,
  Paging,
  Selection,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";
import { exportDataGrid as exportDataGridToXLS } from "devextreme/excel_exporter";
import { exportDataGrid as exportDataGridToPDF } from "devextreme/pdf_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import JsPdf from "jspdf";
import { Modal } from "react-bootstrap";
import useModel from "shared/hooks/useModel";
import { useForm } from "react-hook-form";
import { useLocalStorage } from "react-use";
import InputFields from "shared/component/inputFields";
import { DropDownButton } from "devextreme-react/drop-down-button";
import { Button } from "devextreme-react/button";
import { IPopupOptions } from "devextreme-react/popup";
import { useTranslation } from "react-i18next";
import { SelectBox } from "devextreme-react/select-box";
import Close from "shared/assets/images/svg/close_dialog.svg";
import RefreshIcon from "shared/assets/images/svg/refresh_light.svg";
import PrintIcon from "shared/assets/images/svg/printer_light.svg";
import Setting from "shared/assets/images/svg/settings_light.svg";
import { usePaginate } from "shared/hooks/use-paginate";
import { Column, LoadPanel, IColumnProps, RemoteOperations } from "devextreme-react/data-grid";
import { useLocalize } from "shared/helpers/language";
import _ from "lodash";
import {
  appearanceSettingsState,
  columnsState,
  DataTableAction,
  groupPanelState,
  pagerSettingState,
} from "./dataTableAction";
import { useRecoilState, useRecoilValue } from "recoil";
import DataView from "./dataView";
import { json } from "stream/consumers";

export interface DataColumn extends IColumnProps {
  id: string | number;
}
interface DxfGridProps extends IDataGridOptions {
  layoutKey: string;
  editDialog?: IPopupOptions;
  indexRowLabel?: string;
  keyExpr?: string;
  columns?: DataColumn[];
  isLoading?: boolean;
  hideIndexRow?: boolean;
  actionsElement?: React.ComponentType;
  children?: any;
  summary: any;
  showPreBalance:boolean,
  preBalance:any,
  colsSummery:any[]
}

function DxfGrid({
  indexRowLabel = "numberCol",
  keyExpr,
  dataSource,
  actionsElement: ActionsElement,
  isLoading,
  children,
  layoutKey = "common-layout",
  hideIndexRow = false,
  summary = false,
  editDialog,
  showPreBalance = false,
  preBalance,
  colsSummery=[],
  ...props
}: DxfGridProps) {
  const { t } = useTranslation();
  const gridRef = React.useRef<DataGrid>(null);
  const [page, setPage] = usePaginate();
  const { currentLanguage } = useLocalize();
  const isRTL = currentLanguage?.dir === "rtl";
  const [chooserState, setChooserState] = useState(false);

  const customizeDate = (data:any) => {
    let count = data.value;
    return `${count} item`;
  };
  const customizeSum = (data:any) => {
    return Math.round((data.value + Number.EPSILON) * 100) / 100;
  };

  const [totalItems, setTotalItems] = React.useState([
    {
      column: colsSummery[0],
      summaryType: "sum",
    },
  ]);

  function getRowIndex(pageIndex: number, pageSize: number, rowIndex: number) {
    return pageIndex * pageSize + rowIndex + 1;
  }

  const filterOperation = (dataType: any) => {
    switch (dataType) {
      case "string":
        return ["contains", "notcontains"];
      case "number":
        return ["=", "<>", "<", ">", "<=", ">="];
      case "boolean":
        return [];
      case "date":
        return ["<=", ">="];
      case "datetime":
        return ["<=", ">="];
      default:
        break;
    }
  };
  const statusTypes = [
    { id: true, label: t("dxf-grid.active") },
    { id: false, label: t("dxf-grid.inactive") },
  ];

  const operationDescriptions = {
    between: t("operations.between"),
    contains: t("operations.contains"),
    endsWith: t("operations.endsWith"),
    equal: t("operations.equal"),
    greaterThan: t("operations.greaterThan"),
    greaterThanOrEqual: t("operations.greaterThanOrEqual"),
    lessThan: t("operations.lessThan"),
    lessThanOrEqual: t("operations.lessThanOrEqual"),
    notContains: t("operations.notContains"),
    notEqual: t("operations.notEqual"),
    startsWith: t("operations.startsWith"),
  };


  const handelColapse = (data: any) => {
    if (gridRef.current?.instance.isRowExpanded(data.key)) {
      return (
        <div className="">
          <span>
            {" "}
            {data.value} <small>({data.data.items?.length} items)</small>
          </span>{" "}
          <span></span>
        </div>
      );
    } else {
      return (
        <div className="">
          <span>
            {" "}
            {data.value} <small>({data.data.collapsedItems?.length} items)</small>
          </span>{" "}
          <span></span>
        </div>
      );
    }
  };
  const handleHideCol = (data: any) => {};

  const addMenuItems = (e: any) => {
    const columnField = e.column?.dataField;
    const columnCaption = e.column?.caption;

    if (e.target == "footer" && columnField != null) {
      if (!e.items) e.items = [];
      e.items.push({
        text: t("dxf-grid.sum"),
        onItemClick: function () {
          setTotalItems([{ column: columnField, summaryType: "sum" }]);
        },
      });
      e.items.push({
        text: t("dxf-grid.min"),
        onItemClick: function () {
          setTotalItems([{ column: columnField, summaryType: "min" }]);
        },
      });
      e.items.push({
        text: t("dxf-grid.max"),
        onItemClick: function () {
          setTotalItems([{ column: columnField, summaryType: "max" }]);
        },
      });
      e.items.push({
        text: t("dxf-grid.avg"),
        onItemClick: function () {
          setTotalItems([{ column: columnField, summaryType: "avg" }]);
        },
      });
      e.items.push({
        text: t("dxf-grid.count"),
        onItemClick: function () {
          setTotalItems([{ column: columnField, summaryType: "count" }]);
        },
      });
    }
    if (e.target == "header") {
      if (!e.items) e.items = [];

      e.items.push({
        text: t("dxf-grid.show-group-by-box"),
        onItemClick: () => {
          handleHideCol(columnCaption);
        },
      });
      e.items.push({
        text: t("dxf-grid.group-by-this-column"),
        onItemClick: () => {
          console.log(columnCaption);
        },
      });
      e.items.push({
        text: t("dxf-grid.best-fit"),
        onItemClick: () => {
          handleHideCol(columnCaption);
        },
      });
      e.items.push({
        text: t("dxf-grid.column-chooser"),
        onItemClick: () => {
          gridRef.current?.instance.showColumnChooser();
        },
      });
    }
  };
  const groupPanelSettings = useRecoilValue(groupPanelState);
  const appearanceSettings = useRecoilValue(appearanceSettingsState);
  const pagerSettings = useRecoilValue(pagerSettingState);
  return (
    <>
      <DataTableAction gridRef={gridRef} dataSource={dataSource} layoutKey={layoutKey} children={children}></DataTableAction>
      {showPreBalance && <DataView preBalance={preBalance} />}
      <div className="dataTable">
        <DataGrid
          key={currentLanguage?.code || 'en'}
          export={{allowExportSelectedData:true}}
          ref={gridRef}
          dataSource={dataSource}
          keyExpr={keyExpr}
          hoverStateEnabled
          cacheEnabled={false}
          loadPanel={{ enabled: true }}
          columnFixing={{ enabled: true }}
          columnResizingMode="widget"
          columnMinWidth={50}
          columnAutoWidth={true}
          onContextMenuPreparing={addMenuItems}
          allowColumnReordering={true}
          columnChooser={{ enabled: chooserState }}
          headerFilter={{ visible: false }}
          editing={{ confirmDelete: true }}
          filterPanel={{ visible: false }}
          filterRow={{ visible: true }}
          rtlEnabled={isRTL}
          groupPanel={groupPanelSettings}
          stateStoring={{ enabled: false }}
          onEditorPreparing={(e) => {
            if (e.parentType === "filterRow") {
              e.editorOptions.placeholder = t("common.search");
            }
          }}
          {...appearanceSettings}
          {...props}
        >
           {children}
          <Column
            visible={hideIndexRow}
            cellRender={(data: any) => {
              return getRowIndex(data.component.pageIndex(), data.component.pageSize(), data.rowIndex);
            }}
            caption={t(indexRowLabel)}
            width="100"
            alignment="center"
            dataType="number"
            showInColumnChooser={false}
          />
         

          <ColumnFixing enabled={true} />
          <Paging defaultPageSize={25} pageIndex={page} onPageIndexChange={setPage} />
          <Pager
            visible={pagerSettings.visible}
            allowedPageSizes={pagerSettings.allowedPageSizes}
            showPageSizeSelector={pagerSettings.showPageSizeSelector}
            showInfo={pagerSettings.showInfo}
            showNavigationButtons={pagerSettings.showNavigationButtons}
          />

          {/* {columns?.map(({ id, caption, dataType, ...col }) => (
            <Column
              key={id}
              dataField={id}
              cssClass="vertical-top"
              caption={caption ? t(caption) : undefined}
              alignment={currentLanguage?.dir === "rtl" ? "right" : "left"}
              filterOperations={filterOperation(dataType || "string")}
              dataType={dataType}
              groupCellRender={handelColapse}
              lookup={
                dataType === "boolean"
                  ? {
                      allowClearing: true,
                      dataSource: statusTypes.map((s) => ({
                        id: s.id,
                        label: t(`common:sort.${s.label}`),
                      })),
                      valueExpr: "id",
                      displayExpr: "label",
                    }
                  : undefined
              }
              {...col}
            />
          ))} */}

          {ActionsElement && (
            <Column
              fixedPosition="right"
              cssClass="action-overflow"
              alignment="center"
              allowExporting={false}
              width="70"
              cellRender={(cellProps) => <ActionsElement {...cellProps} />}
            />
          )}
          <Selection mode="multiple" showCheckBoxesMode="always"  deferred={true}/>
          <RemoteOperations
            paging={true}
            groupPaging={true}
            grouping={false}
            filtering={true}
            sorting={false}
            summary={false}
            
          />
          <Summary >
            {/* <TotalItem column={colsSummery[0]} summaryType="sum"  customizeText={customizeSum}  />
            <TotalItem column={colsSummery[1]} summaryType="count" customizeText={customizeDate}  /> */}
            <GroupItem column={colsSummery[0]} summaryType="sum" showInGroupFooter={true} customizeText={customizeSum} />
            <GroupItem column={colsSummery[1]} summaryType="count" customizeText={customizeDate} showInGroupFooter={true} />
          </Summary>
          
        </DataGrid>
      </div>
    </>
  );
}

export default DxfGrid;
